import { ArgsProps, NotificationInstance } from 'antd/es/notification/interface';
import { makeAutoObservable } from 'mobx';

export class NotificationStore {
  private _api: NotificationInstance | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  public initNotifications(api: NotificationInstance) {
    this._api = api;
  }

  open(args: ArgsProps) {
    this._api?.open(args);
  }

  success(title: string) {
    this._api?.success({
      message: title,
    });
  }

  error(title: string) {
    this._api?.error({
      message: title,
    });
  }
}

const notificationStore = new NotificationStore();
export default notificationStore;
